// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"165":"3f314bee","182":"d68210c2","228":"91131596","477":"97a642fb","681":"0bf5c67c","725":"b90f3d4c","781":"2fb54476"}[chunkId] + ".chunk.js";
};